const unwrapEl = (el) => {
  if (!el) {
    return;
  }
  if ("$el" in el) {
    return el.$el;
  }
  return el;
};
export {
  unwrapEl as u
};
//# sourceMappingURL=unwrapEl-55936fea.mjs.map
